<template>
  <div class="w-100 h-100" style="position:relative">
    <ul class="metadata-dock-ul" ref="metadataDockUl" :class="isMetadataDock?'':'align-texts'" v-on:scroll="loadMoreSubclips($event)">
      <div class="w-100" style="display: inline-flex;align-items:center">    
        <div v-if="shouldShowMetadata" class="select-filters">
          <div v-if="shouldShowMetadata" :class="{activeFilter:selectedFilter == 'Metadata'}" @click="changeFilter('Metadata')" class="notification-filters">{{$t('Metadata')}}</div>
          <div v-if="isEnabled('Sub Clips') && (isVideoFile || isAudioFile) && assetDetails.asset_type != 'subclip'" :class="{activeFilter:selectedFilter == 'Subclips'}" @click="changeFilter('Subclips')" class="notification-filters">{{$t('Subclips')}}</div>
          <div v-if="isPluginInstalled('Transcript') && assetDetailsFromParent && assetDetailsFromParent.hasOwnProperty('ai_info') &&
          assetDetailsFromParent.ai_info && assetDetailsFromParent.ai_info.transcript &&
          assetDetailsFromParent.ai_info.transcript.length > 0" :class="{activeFilter:selectedFilter == 'Transcript'}" @click="changeFilter('Transcript')" class="notification-filters">{{$t('Transcript')}}</div>
          <div  v-if="isPluginInstalled('Face detection') && assetDetailsFromParent && assetDetailsFromParent.hasOwnProperty('ai_info') && assetDetailsFromParent.ai_info && assetDetailsFromParent.ai_info.face_detection && assetDetailsFromParent.ai_info.face_detection.length > 0" :class="{activeFilter:selectedFilter == 'Faces'}" @click="changeFilter('Faces')" class="notification-filters">{{$t('Faces')}}</div>
          <div v-if="isPluginInstalled('OBD') && assetDetailsFromParent && assetDetailsFromParent.hasOwnProperty('ai_info') && assetDetailsFromParent.ai_info && assetDetailsFromParent.ai_info.obd && assetDetailsFromParent.ai_info.obd.length > 0" :class="{activeFilter:selectedFilter == 'Objects'}" @click="changeFilter('Objects')" class="notification-filters">{{$t('Objects')}}</div>
          <div v-if="isPluginInstalled('OCR') && assetDetailsFromParent && assetDetailsFromParent.hasOwnProperty('ai_info') && assetDetailsFromParent.ai_info && assetDetailsFromParent.ai_info.ocr && assetDetailsFromParent.ai_info.ocr.length > 0" :class="{activeFilter:selectedFilter == 'OCR'}" @click="changeFilter('OCR')" class="notification-filters">{{$t('OCR')}}</div>
          <template v-for="list in getMetadataDockListPlugins.filter(op=>('position' in op))">
            <div v-if="isPluginInstalled(list.privilegeId)" :key="list.id" :class="{activeFilter:selectedFilter == list.name}" @click="changeFilter(list.name)" class="notification-filters">{{$t(list.label)}}</div>
          </template>
        </div>
        <span class="metadata-refresh-option" @click="reloadMetadataFieldValues()" style="float:inline-end;position:relative;">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
            <title>{{ $t('Reload Metadata') }}</title>
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
          </svg>
        </span> 
      </div>   
      <div :style="shouldShowMetadata?'height: calc(100% - 40px)': 'height:100%'" class="metadata-dock-sub-div">
        <li v-if="globalSettingsFromStartup.enable_department && ((assetDetailsFromParent.file_type && ['file'].includes(assetDetailsFromParent.file_type)) || ['file','subclip'].includes(assetDetailsFromParent.asset_type)|| (assetDetailsFromParent.asset_type == 'catalog' && assetDetailsFromParent.catalog_type == 'photo_album'))" id="metadatafirstediticon" tabindex="0" @dblclick="editMetadataDockFields('Project')" class="ml-2" style="margin-top:10px;">
          <div style="display:flex;">
            <div class="key-style">{{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</div>
            <span style="color:#858585"> *</span>
          </div>
          <div class="value-style d-inline-flex" style="cursor:pointer">
              <div class="w-100"
                  v-if="!isMetadataEdit('Project')">
                <div class="d-inline-flex w-100">
                    <span
                    v-if="selectedDepartments && selectedDepartments.name"
                    class="slug-ellipsis"
                    >{{ selectedDepartments.name }}</span
                    >
                    <span
                    v-else
                    class="config-desc"
                    >NONE</span
                    >
                    <edit-icon
                    tabindex="0" @click.native="editMetadataDockFields('Project')"
                    class="editIcon"
                    ></edit-icon>
                </div>
                <div v-if="isTypeCatalog"  style="padding-top: 9px;">
                  <div v-if="showLoadingGif" style="height:35px;padding-bottom:10px 0px">
                    <img :src="loadingGif" style="height:35px;position: relative;inset-inline-end :17px;">
                  </div>
                  <div v-if="isJobInitialted" style="padding-bottom:10px 0px">
                    <span style="font-size: 14px;color:#858585;">Applying recursively. Updated
                        <span style="color:#eeeeee"> {{updatedAssetsCount}} </span>
                        out of
                        <span style="color:#eeeeee"> {{totalAssetsCount}} </span>
                        <span v-if="totalAssetsCount.length > 1">files. </span>
                        <span v-else>file. </span>
                    </span>
                    <div class="progress" style="height: 20px;border-radius: 9px;margin-top: 10px;background-color: rgb(38 41 43 / 58%);border: 1px solid rgb(71 71 71);">
                        <div v-if="!isJobFailed" class="progress-bar" role="progressbar" style="border-radius: 4px;"
                        :aria-valuenow='progressValue' aria-valuemin="0" aria-valuemax="100" :style="{width:progressValue + '%'}">
                        </div>
                    </div>
                    <div v-if="isJobFailed" style="color:#ff3636;padding:10px 0px">{{errorMessage}}</div>
                    <div class="mt-3 primary-btn-style">
                        <button v-if="progressValue != 100 || !isJobFailed" class="btn btn-outline-secondary mr-2" data-dismiss="modal" v-on:click="reloadJobDetails()">Reload</button>
                    </div>
                </div>
                </div>
              </div>
              <div v-else class="w-100">
                <div class="d-flex" >
                    <departmentsCommonComponent ref="departmentsField" :isDropdown='true' :selectedProject="selectedDepartments" @updateSelectedDepartments="updateSelectedDepartments"></departmentsCommonComponent>
                    <save-icon  tabindex="0" @click.native="saveFields('Project')" class="save-cancel-icon"></save-icon>
                    <cancel-icon  tabindex="0"
                    @click.native="cancelMetadataDockFields('Project')"  class="save-cancel-icon"
                    ></cancel-icon>
                </div>
                <div v-if="isTypeCatalog"  style="padding-top: 9px;">
                  <div v-if="showLoadingGif" style="height:35px;padding-bottom:10px 0px">
                    <img :src="loadingGif" style="height:35px">
                  </div>
                  <div v-if="isJobInitialted" style="padding-bottom:10px 0px">
                    <span style="font-size: 14px;color:#858585;">Applying recursively. Updated
                        <span style="color:#eeeeee"> {{updatedAssetsCount}} </span>
                        out of
                        <span style="color:#eeeeee"> {{totalAssetsCount}} </span>
                        <span v-if="totalAssetsCount.length > 1">files. </span>
                        <span v-else>file. </span>
                    </span>
                    <div class="progress" style="height: 20px;border-radius: 9px;margin-top: 10px;background-color: rgb(38 41 43 / 58%);border: 1px solid rgb(71 71 71);">
                        <div v-if="!isJobFailed" class="progress-bar" role="progressbar" style="border-radius: 4px;"
                        :aria-valuenow='progressValue' aria-valuemin="0" aria-valuemax="100" :style="{width:progressValue + '%'}">
                        </div>
                    </div>
                    <div v-if="isJobFailed" style="color:#ff3636;padding:10px 0px">{{errorMessage}}</div>
                    <div class="mt-3 primary-btn-style">
                        <button v-if="progressValue != 100 || !isJobFailed" class="btn btn-outline-secondary mr-2" data-dismiss="modal" v-on:click="reloadJobDetails()">Reload</button>
                    </div>
                </div>
                </div>
              </div>
          </div>
        </li>
        <li v-if="globalSettingsFromStartup.enable_reference_id_workflow && ( (assetDetailsFromParent.file_type && ['file'].includes(assetDetailsFromParent.file_type)) || (assetDetailsFromParent.asset_type && ['file'].includes(assetDetailsFromParent.asset_type)))" id="metadatafirstediticon" tabindex="0" @dblclick="globalSettingsFromStartup.allow_refrence_id_to_edit?editMetadataDockFields('RefID'):''" class="ml-2" style="margin-top:10px;">
          <div style="display:flex;">
            <div class="key-style">{{globalSettingsFromStartup.alias &&  globalSettingsFromStartup.alias.alias_name?globalSettingsFromStartup.alias.alias_name:"Reference ID"}}</div>
          </div>
          <div class="value-style d-inline-flex" style="cursor:pointer">
              <div class="w-100"
                  v-if="!isMetadataEdit('RefID')">
                <div class="d-inline-flex w-100">
                    <span
                    v-if="referenceID && referenceID"
                    class="slug-ellipsis"
                    >{{ referenceID }}</span
                    >
                    <span
                    v-else
                    class="config-desc"
                    >NONE</span
                    >
                    <edit-icon v-if="globalSettingsFromStartup.allow_refrence_id_to_edit"
                    tabindex="0" @click.native="editMetadataDockFields('RefID')"
                    class="editIcon"
                    ></edit-icon>
                </div>
              </div>
              <div v-else class="w-100">
                <div class="d-flex" >
                  <input
                    v-model="referenceID"
                    type="text"
                    ref="slug_name"
                    :placeholder="globalSettingsFromStartup.alias &&  globalSettingsFromStartup.alias.alias_name?'Enter '+globalSettingsFromStartup.alias.alias_name:'Enter Reference ID'"
                    class="bg-transparent border rounded text-light w-100 input-fields"
                    
                    />
                    <save-icon  tabindex="0" @click.native="saveFields('RefID')" class="save-cancel-icon"></save-icon>
                    <cancel-icon  tabindex="0"
                    @click.native="cancelMetadataDockFields('RefID')"  class="save-cancel-icon"
                    ></cancel-icon>
                </div>
              </div>
          </div>
        </li>
        <div ref="Metadata">
          <div
              class="text-left"
              style="padding: 10px 0px 10px 8px; color: #777;position: relative;"
          >
          <svg  v-if="!showMetadata" v-on:click="showMetadata = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
              <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
          </svg>
          <svg v-if="showMetadata" v-on:click="showMetadata = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
              <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg>
            <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">{{$t('Metadata')}}</span>
            <span v-if="displayMessage" style="padding: 7px;word-break: break-all;color: #cd8600;font-size:12px;border: 1px solid #3c3c3c;
            margin-inline-start: 9px;
            border-radius: 5px;
            background: #202528;">{{displayMessage}}</span>
            <!-- <component :is="metadataPromptsComponent" :buttonStyles="getAIButtonStyles()" :assetDetailsFromParent="assetDetailsFromParent" :showMetadata="showMetadata" :screenType="screenType"/> -->
            <component :is="metadataSmartExtractComponent" :buttonStyles="getMetadataSmartExtractButtonStyles()" :assetDetailsFromParent="assetDetailsFromParent" :showMetadata="showMetadata" :screenType="screenType"/>    
             <!-- SMART EXTRACTION DROPDOWN -->
            <div
                class="smart-extraction-dropdown-wrapper"
                @click.stop
            >
                <svg
                    @click="showSmartExtractionMenu = !showSmartExtractionMenu"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-caret-down-fill smart-extraction-dropdown-icon"
                    viewBox="0 0 16 16"
                >
                    <path
                        d="M7.247 11.14 2.451 5.658C1.885 5.013
                        2.345 4 3.204 4h9.592a1 1 0 0 1
                        .753 1.659l-4.796 5.48a1 1 0 0
                        1-1.506 0z"
                    />
                </svg>

                <div
                    v-if="showSmartExtractionMenu"
                    class="smart-extraction-dropdown-menu"
                >
                    <div
                        class="smart-extraction-dropdown-item"
                        @click="openSmartExtraction"
                    >
                        {{ $t('AI Prompts') }}
                    </div>
                </div>
            </div>

            <!-- SMART EXTRACTION COMPONENT -->
            <!-- <component
                ref="metadataSmartExtractRef"
                :is="metadataSmartExtractComponent"
                :buttonStyles="getMetadataSmartExtractButtonStyles()"
                :assetDetailsFromParent="assetDetailsFromParent"
                :showMetadata="showMetadata"
                :screenType="screenType"
                :hideTriggerButton="true"
            /> -->

            <!-- AI Prompts-->
             <component 
              ref="AIPromptsRef"
              :is="metadataPromptsComponent" 
              :buttonStyles="getAIButtonStyles()" 
              :assetDetailsFromParent="assetDetailsFromParent" 
              :showMetadata="showMetadata" 
              :screenType="screenType"
              :hideTriggerButton="true"/>
          </div>
          <template v-if="showMetadata">
            <li id="metadatafirstediticon" tabindex="0" v-if="!isSubclipEnabled && !isTypeCatalog" @dblclick="editMetadataOnDoubleclick('slug_name')" :class="{readonlyDiv:isTypeCatalog}">
              <div style="display:flex">
                <div class="key-style">{{$t('Media Slug')}}</div>
                <span style="color:#858585"> *</span>
              </div>
              <div class="value-style d-inline-flex">
                  <div class="w-100"
                      v-if="!isMetadataEdit('slug_name')">
                  <div class="d-inline-flex w-100">
                      <span
                      class="slug-ellipsis"
                      >{{ slugName }}</span
                      >
                      <edit-icon v-if="isMetadataPrivEnabled()"
                      tabindex="0" @click.native="editMetadataDockFields('slug_name')"
                      class="editIcon"
                      
                      ></edit-icon>
                  </div>
                  </div>
                  <div v-else class="w-100">
                  <div class="d-flex">
                      <input
                      v-model="postData.slug_name"
                      type="text"
                      ref="slug_name"
                      placeholder="Enter Slug name"
                      class="bg-transparent border rounded text-light w-100 input-fields"
                      
                      />
                      <save-icon :wrapcontentwithbutton="true" tabindex="0" @click.native="saveFields('slug_name')" class="save-cancel-icon"></save-icon>
                      <cancel-icon :wrapcontentwithbutton="true" tabindex="0"
                      @click.native="cancelMetadataDockFields('slug_name')"  class="save-cancel-icon"
                      ></cancel-icon>
                  </div>
                  </div>
              </div>
            </li>

            <li v-if="!(globalSettingsFromStartup.configure_catalogs_from_screen)" @dblclick="globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY?'':editMetadataOnDoubleclick('category')" :class="{readonlyDiv:isTypeCatalog || globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY}">
              <div class="key-style">{{$t('Catalogs')}}
                <span class="readonly-field" v-if="isTypeCatalog || globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY">
                                  ( non editable )
                </span>
              </div>
              <div class="value-style d-inline-flex">
                  <div class="w-100">
                    <div v-if="!isMetadataEdit('category')" class="d-inline-flex">
                        <ul class="tags-display-ul p-0" style="display:inline-flex">
                          <template v-for="opt in selectedCatParentIdPathList">
                            <div v-bind:key=opt._id>
                              <li class="view-tags" :title='getCatParentName(opt)'>
                                <label style="word-break: break-all;margin-bottom: 0px;">{{ opt.catalog_name }}</label>
                              </li>
                            </div>
                          </template>
                        </ul>
                        <edit-icon
                          tabindex="0" @click.native="editMetadataDockFields('category')"
                          v-show="!isMetadataEdit('category') && isMetadataPrivEnabled() && !isTypeCatalog && !(globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY)"
                          class="editIcon"
                        >
                        </edit-icon>
                    </div>
                    <catalog-dropdown ref="catalogMultiPicklist" v-if="isMetadataEdit('category')"
                                    :enableCatBrowser="true"
                                    :selectedOptions="selectedCatParentIdPathList"
                                    @removedCatalogFromList="removedCatalogFromList"
                                    @updatedCatalogsList="updatedCatalogsListComp"
                                    :browserPermissions="['full-control','read-modify','read-write']"
                                    :allowSingleSelect="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                    :allowSingleSelectFromBrowse="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                    from="TagMetadata"
                                    ></catalog-dropdown>
                  </div>
                  <div v-show="isMetadataEdit('category')">
                    <div class="d-flex" style="height:30px;">
                        <save-icon :wrapcontentwithbutton="true"
                        tabindex="0" @click.native="saveFields(postcatalogKey)"
                        class="save-cancel-icon"
                        ></save-icon>
                        <cancel-icon tabindex="0" :wrapcontentwithbutton="true"
                        @click.native="cancelMetadataDockFields('category')"
                        class="save-cancel-icon"
                        ></cancel-icon>
                    </div>
                  </div>
              </div>
            </li>

            <li v-if="metadataProfileList.length > 0 && ![undefined,null].includes(relevantProfilesList) && relevantProfilesList.length > 0" @dblclick="editMetadataOnDoubleclick('profiles')" :class="isMetadataEdit('profiles')?'li-style-change':''">
              <div class="upload-fields">
                  <div class="key-style">{{$t('Screen Profile')}}</div>
                  <div class="value-style d-inline-flex">
                    <div class="w-100">
                      <div v-if="!isMetadataEdit('profiles')">
                          <ul class="tags-display-ul p-0" style="display:inline-flex">
                          <template v-for="rpId in selectedRelaventProfileIdList">
                              <div v-bind:key = rpId>
                              <li v-if="rpId != 'All'"
                                      :key="rpId"
                                      class="view-tags">
                                      <label class="mb-0">{{ getSelectedProfileName(rpId) }}</label>
                              </li>
                              </div>
                          </template>
                          </ul>
                          <edit-icon
                          tabindex="0" @click.native="editMetadataDockFields('profiles')"
                          v-show="!isMetadataEdit('profiles') && isMetadataPrivEnabled()"
                          class="editIcon"
                          ></edit-icon>
                      </div>
                      <Multiselect
                          v-if="isMetadataEdit('profiles')"
                          v-model="checkedProfiles" 
                          :options="relevantProfilesList"
                          :multiple="true"
                          track-by="metadata_profile_id"
                          :custom-label="screenProfileLabelCallback"
                          :close-on-select="true"
                          :show-no-results="false"
                          deselectLabel =""
                          selectLabel=""
                          selectedLabel=""
                          ref="profiles"
                          placeholder="Enter profile"
                          :hideSelected="false"
                          :showNoOptions="false"
                          @remove="removeProfile($event)"
                          @select="selectProfile($event)">
                          <span slot="noResult">No results</span>
                          <span slot="noOptions" style="display:none"></span>
                          <div slot="tag" slot-scope="option" class="selected-tags-style">
                          <div class="tags-display-style">{{option.option.name}}</div>
                          <div class="remove-tag" v-on:click="removeSelectedOption(option.option)">
                              <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                              </svg>
                          </div>
                          </div>
                          <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                          <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeProfileCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
                          <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                          </div>
                      </Multiselect>
                    </div>
                    <div v-show="isMetadataEdit('profiles')">
                          <cancel-icon tabindex="0" :wrapcontentwithbutton="true"
                              @click.native="cancelMetadataDockFields('profiles')"
                              class="save-cancel-icon"
                          ></cancel-icon>
                    </div>
                  </div>
              </div>
            </li>

            <li v-if="!(globalSettingsFromStartup.configure_description_from_screen) && !isSubclipEnabled" @dblclick="editMetadataOnDoubleclick('description')" :class="isMetadataEdit('description')?'li-style-change':''">
              <div class="key-style">{{$t('Description')}}</div>
              <div class="value-style d-inline-flex">
                  <div class="w-100">
                  <div class="d-inline-flex">
                      <span v-show="!isMetadataEdit('description')">{{
                      description
                      }}</span>
                      <edit-icon :wrapcontentwithbutton="true"
                      tabindex="0" @click.native="editMetadataDockFields('description')"
                      v-show="!isMetadataEdit('description') && isMetadataPrivEnabled()"
                      class="editIcon"
                      ></edit-icon>
                  </div>
                  <textarea
                      v-model="postData.metadata.description"
                      v-show="isMetadataEdit('description')"
                      ref="description"
                      class="bg-transparent border rounded text-light input-fields w-100"
                  ></textarea>
                  </div>
                  <div v-if="isMetadataEdit('description')">
                  <div class="d-flex">
                      <save-icon :wrapcontentwithbutton="true"
                      tabindex="0" @click.native="saveFields('description')"
                      class="save-cancel-icon"
                      ></save-icon>
                      <cancel-icon tabindex="0" :wrapcontentwithbutton="true"
                      @click.native="cancelMetadataDockFields('description')"
                      class="save-cancel-icon"
                      ></cancel-icon>
                  </div>
                  </div>
              </div>
            </li>

            <li v-if="!(globalSettingsFromStartup.configure_tags_from_screen) && (profileDetails.tag_displayall_config > 0||
                                          (profileDetails.tag_display_config > 0) ||
                                          selectedRelaventProfileIdList.includes('All'))"
                                @dblclick="editMetadataOnDoubleclick('tags')" :class="isMetadataEdit('tags')?'li-style-change':''">
                              <div class="key-style">{{$t('Tags')}}</div>
                              <div class="value-style d-inline-flex" style="margin-inline-start:3px;">
                                  <div class="w-100">
                                      <div v-if="!isMetadataEdit('tags')">
                                      <ul class="tags-display-ul p-0" style="display:inline-flex">
                                          <template v-for="tagId in selectedTags">
                                          <div :key="tagId" v-if="profileDetails.tag_displayall_config > 0||
                                          (profileDetails.tag_display_config > 0 && fetchedTagIdList.includes(tagId._id)) ||
                                          selectedRelaventProfileIdList.includes('All')">
                                          <li
                                              :key="tagId"
                                              class="view-tags">
                                              <div>{{ tagId.name }}</div>
                                              <cancel-icon tabindex="0" :wrapcontentwithbutton="true" v-show="isMetadataEdit('tags')" class="show-tags-delete" @click.native="deleTagIdFromList(tagId._id)"></cancel-icon>
                                          </li>
                                          </div>
                                          </template>
                                      </ul>
                                      <edit-icon
                                          tabindex="0" @click.native="editMetadataDockFields('tags')"
                                          v-show="!isMetadataEdit('tags') && isMetadataPrivEnabled()"
                                          class="editIcon"
                                      ></edit-icon>
                                      </div>
                                  <Multiselect
                                      v-if="isMetadataEdit('tags')"
                                      v-model="selectedTags" 
                                      :options="tagsListFromAutocomplete"
                                      :multiple="true"
                                      track-by="_id"
                                      ref="tags"
                                      :custom-label="tagsLabelCallback"
                                      :close-on-select="false"
                                      :show-no-results="false"
                                      deselectLabel =""
                                      selectLabel=""
                                      selectedLabel=""
                                      placeholder="Enter tagname"
                                      :hideSelected="false"
                                      :showNoOptions="false"
                                      @open="getTagNamesFromServer"
                                      @search-change="getTagsOnKeyup($event)"
                                      @remove="removeTags($event)"
                                      @select="selectTags($event)">
                                      <span slot="noResult">No results</span>
                                      <span slot="noOptions" style="display:none"></span>
                                      <div slot="tag" slot-scope="option" class="selected-tags-style">
                                      <div class="tags-display-style">{{option.option.name}}</div>
                                          <div class="remove-tag" v-on:click="removeSelectedTagOption(option.option)">
                                              <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                              <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                              </svg>
                                          </div>
                                      </div>
                                      <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                      <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeTagsCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
                                      <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                                      </div>
                                  </Multiselect>
                                  </div>
                                  <div v-show="isMetadataEdit('tags')" style="display:inline-flex;">
                                  <div class="d-flex" >
                                  <browse-icon :wrapcontentwithbutton="true" title="Browse tag(s)" v-on:click.native="openTagsBrowse()" v-show="isMetadataEdit('tags')" class="save-cancel-icon browse-icon tagsbrowse" style="width:40px;height:30px;"></browse-icon>
                                  <save-icon :wrapcontentwithbutton="true" tabindex="0" @click.native="saveFields('tags')" v-show="isMetadataEdit('tags')" class="save-cancel-icon" style="width:40px;height:30px;"></save-icon>
                                  <cancel-icon :wrapcontentwithbutton="true" tabindex="0" @click.native="cancelMetadataDockFields('tags')" v-show="isMetadataEdit('tags')" class="save-cancel-icon" style="width:40px;height:30px;"></cancel-icon>
                                  </div>
                              </div>   
                              </div>
            </li>

            <template>
              <div v-for="eachId in metadataScreenInfo.field_id_list" :key="eachId" class="fields-styles">
                <div v-if="displayAlwaysFieldsIdList.includes(eachId) || profileDetails.custom_metadata_allId_list ||
                      (profileDetails.custom_metadata_display_config > 0 && fetchedFieldIdList.includes(eachId)) ||
                      selectedRelaventProfileIdList.includes('All')">
                      <template v-if="eachId == 'Tags'">
                        <li v-if="globalSettingsFromStartup.configure_tags_from_screen && (profileDetails.tag_displayall_config > 0||
                                          (profileDetails.tag_display_config > 0) ||
                                          selectedRelaventProfileIdList.includes('All'))"
                                @dblclick="editMetadataOnDoubleclick('tags')" :class="isMetadataEdit('tags')?'li-style-change':''">
                              <div class="key-style">{{$t('Tags')}}</div>
                              <div class="value-style d-inline-flex" style="margin-inline-start:3px;">
                                  <div class="w-100">
                                      <div v-if="!isMetadataEdit('tags')">
                                      <ul class="tags-display-ul p-0" style="display:inline-flex">
                                          <template v-for="tagId in selectedTags">
                                          <div :key="tagId" v-if="profileDetails.tag_displayall_config > 0||
                                          (profileDetails.tag_display_config > 0 && fetchedTagIdList.includes(tagId._id)) ||
                                          selectedRelaventProfileIdList.includes('All')">
                                          <li
                                              :key="tagId"
                                              class="view-tags">
                                              <div>{{ tagId.name }}</div>
                                              <cancel-icon tabindex="0" :wrapcontentwithbutton="true" v-show="isMetadataEdit('tags')" class="show-tags-delete" @click.native="deleTagIdFromList(tagId._id)"></cancel-icon>
                                          </li>
                                          </div>
                                          </template>
                                      </ul>
                                      <edit-icon
                                          tabindex="0" @click.native="editMetadataDockFields('tags')"
                                          v-show="!isMetadataEdit('tags') && isMetadataPrivEnabled()"
                                          class="editIcon"
                                      ></edit-icon>
                                      </div>
                                  <Multiselect
                                      v-if="isMetadataEdit('tags')"
                                      v-model="selectedTags" 
                                      :options="tagsListFromAutocomplete"
                                      :multiple="true"
                                      track-by="_id"
                                      ref="tags"
                                      :custom-label="tagsLabelCallback"
                                      :close-on-select="false"
                                      :show-no-results="false"
                                      deselectLabel =""
                                      selectLabel=""
                                      selectedLabel=""
                                      placeholder="Enter tagname"
                                      :hideSelected="false"
                                      :showNoOptions="false"
                                      @open="getTagNamesFromServer"
                                      @search-change="getTagsOnKeyup($event)"
                                      @remove="removeTags($event)"
                                      @select="selectTags($event)">
                                      <span slot="noResult">No results</span>
                                      <span slot="noOptions" style="display:none"></span>
                                      <div slot="tag" slot-scope="option" class="selected-tags-style">
                                      <div class="tags-display-style">{{option.option.name}}</div>
                                          <div class="remove-tag" v-on:click="removeSelectedTagOption(option.option)">
                                              <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                              <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                              </svg>
                                          </div>
                                      </div>
                                      <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                      <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeTagsCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
                                      <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
                                      </div>
                                  </Multiselect>
                                  </div>
                                  <div v-show="isMetadataEdit('tags')" style="display:inline-flex;">
                                  <div class="d-flex" >
                                  <browse-icon :wrapcontentwithbutton="true" title="Browse tag(s)" v-on:click.native="openTagsBrowse()" v-show="isMetadataEdit('tags')" class="save-cancel-icon browse-icon tagsbrowse" style="width:40px;height:30px;"></browse-icon>
                                  <save-icon :wrapcontentwithbutton="true" tabindex="0" @click.native="saveFields('tags')" v-show="isMetadataEdit('tags')" class="save-cancel-icon" style="width:40px;height:30px;"></save-icon>
                                  <cancel-icon :wrapcontentwithbutton="true" tabindex="0" @click.native="cancelMetadataDockFields('tags')" v-show="isMetadataEdit('tags')" class="save-cancel-icon" style="width:40px;height:30px;"></cancel-icon>
                                  </div>
                              </div>   
                              </div>
                        </li>
                      </template>
                      <template v-else-if="eachId == 'Catalogs'">
                        <li v-if="globalSettingsFromStartup.configure_catalogs_from_screen" @dblclick="globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY?'':editMetadataOnDoubleclick('category')" :class="{readonlyDiv:isTypeCatalog || globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY}">
                          <div class="key-style">{{$t('Catalogs')}}
                            <span class="readonly-field" v-if="isTypeCatalog || globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY">
                              ( non editable )
                            </span>
                          </div>
                          <div class="value-style d-inline-flex">
                            <div class="w-100">
                              <div v-if="!isMetadataEdit('category')" class="d-inline-flex">
                                <ul class="tags-display-ul p-0" style="display:inline-flex">
                                  <template v-for="opt in selectedCatParentIdPathList">
                                    <div v-bind:key = opt._id>
                                      <li class="view-tags" :title='getCatParentName(opt)'>
                                        <label style="word-break: break-all;margin-bottom: 0px;">{{ opt.catalog_name }}</label>
                                      </li>
                                    </div>
                                  </template>
                                </ul>
                                <edit-icon
                                  tabindex="0" @click.native="editMetadataDockFields('category')"
                                  v-show="!isMetadataEdit('category') && isMetadataPrivEnabled() && !isTypeCatalog && !(globalSettingsFromStartup && globalSettingsFromStartup.CATALOG_READ_ONLY)"
                                  class="editIcon"
                                  >
                                </edit-icon>
                              </div>
                              <catalog-dropdown ref="catalogMultiPicklist" v-if="isMetadataEdit('category')"
                                  :enableCatBrowser="true"
                                  :selectedOptions="selectedCatParentIdPathList"
                                  @removedCatalogFromList="removedCatalogFromList"
                                  @updatedCatalogsList="updatedCatalogsListComp"
                                  :browserPermissions="['full-control','read-modify','read-write']"
                                  :allowSingleSelect="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                  :allowSingleSelectFromBrowse="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                  from="TagMetadata"
                                  >
                              </catalog-dropdown>
                            </div>
                            <div v-show="isMetadataEdit('category')">
                              <div class="d-flex" style="height:30px;">
                                <save-icon :wrapcontentwithbutton="true"
                                  tabindex="0" @click.native="saveFields(postcatalogKey)"
                                  class="save-cancel-icon">
                                </save-icon>
                                <cancel-icon tabindex="0" :wrapcontentwithbutton="true"
                                  @click.native="cancelMetadataDockFields('category')"
                                  class="save-cancel-icon">
                                </cancel-icon>
                              </div>
                            </div>
                          </div>
                        </li>
                      </template>
                      <template v-else-if="eachId == 'Description'">
                        <li v-if="globalSettingsFromStartup.configure_description_from_screen && !isSubclipEnabled" @dblclick="editMetadataOnDoubleclick('description')" :class="isMetadataEdit('description')?'li-style-change':''">
                          <div class="key-style">{{$t('Description')}}</div>
                          <div class="value-style d-inline-flex">
                            <div class="w-100">
                              <div class="d-inline-flex">
                                <span v-show="!isMetadataEdit('description')">{{description}}</span>
                                <edit-icon :wrapcontentwithbutton="true"
                                  tabindex="0" @click.native="editMetadataDockFields('description')"
                                  v-show="!isMetadataEdit('description') && isMetadataPrivEnabled()"
                                  class="editIcon"
                                  >
                                </edit-icon>
                              </div>
                              <textarea
                                  v-model="postData.metadata.description"
                                  v-show="isMetadataEdit('description')"
                                  ref="description"
                                  class="bg-transparent border rounded text-light input-fields w-100"
                              >
                              </textarea>
                            </div>
                            <div v-if="isMetadataEdit('description')">
                              <div class="d-flex">
                                <save-icon :wrapcontentwithbutton="true"
                                  tabindex="0" @click.native="saveFields('description')"
                                  class="save-cancel-icon">
                                </save-icon>
                                <cancel-icon tabindex="0" :wrapcontentwithbutton="true"
                                  @click.native="cancelMetadataDockFields('description')"
                                  class="save-cancel-icon">
                                </cancel-icon>
                              </div>
                            </div>
                          </div>
                        </li>
                      </template>
                    <template v-else>
                  <div v-for="custommetadata in (customMetadataList.filter((cmdata)=>(cmdata._id == eachId && (!('load_when' in cmdata) || (cmdata['load_when'].length == 0)))))" :key="custommetadata._id">
                    <template v-if="!('definition_type' in custommetadata) ||
                    ('definition_type' in custommetadata && custommetadata.definition_type == 'user-defined')">
                      <li  :id="'field-'+custommetadata._id" class="d-block" :key="custommetadata._id"
                            @dblclick="editMetadataOnDoubleclick(custommetadata.name,custommetadata._id, custommetadata.type,custommetadata.type == 'PICKLIST_MULTIVALUE')"
                            :class="{'readonlyDiv':metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id),'li-style-change':isMetadataEdit(custommetadata.name)}">
                        <div style="display: flex;">
                            <div class="upload-fields" :class="{readonlyDiv:metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id)}">
                            <div style="display: flex;">
                              <div class="key-style">{{ getCustomMetadataName(custommetadata) }}
                                <span class="readonly-field" v-if="metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id)">
                                    ( non editable )
                                </span>
                              </div>
                              <span style="color:#858585" v-if="metadataScreenInfo.mandatory_field_id_list != undefined && metadataScreenInfo.mandatory_field_id_list.includes(custommetadata._id)">*</span>
                            </div>
                            <div class="value-style d-inline-flex">
                                <div class="w-100" style="display: inherit">
                                <div class="d-inline-flex">
                                    <template v-if="!isMetadataEdit(custommetadata.name)">
                                      <template v-if="custommetadata.type=='PICKLIST_MULTIVALUE'">
                                          <div>
                                            <ul class="tags-display-ul p-0">
                                              <li
                                              v-for="picklist in pickListMapper[custommetadata._id]"
                                              :key="picklist.value_id"
                                              class="view-tags"
                                              >
                                                <div style="position:relative;top:1px">{{ picklist.value }}</div>
                                              </li>
                                            </ul>
                                          </div>
                                      </template>
                                      <template v-else-if="custommetadata.type == 'PICKLIST'">
                                        <span>{{getSinglePicklistVal(custommetadata._id)}}</span>
                                      </template>
                                      <template v-else-if="['DATE', 'DATE_TIME'].includes(custommetadata.type)">
                                        <span>{{getAssetDateTimeValue(custommetadata)}}</span>
                                      </template>
                                      <template v-else>
                                          <span>{{getCustomMetadataValue(custommetadata._id)}}</span>
                                      </template>
                                    </template>
                                    <edit-icon
                                    tabindex="0" @click.native="editMetadataDockFields(custommetadata.name,custommetadata._id, custommetadata.type,(custommetadata.type == 'PICKLIST_MULTIVALUE'))"
                                    v-show="!isMetadataEdit(custommetadata.name) && isMetadataPrivEnabled() &&
                                    !(metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id))"
                                    class="editIcon"
                                    ></edit-icon>
                                    <div class="aboutField" :title="custommetadata.about_field" v-if="Object.keys(custommetadata).includes('about_field') &&
                                    custommetadata.about_field.length" @click="enableOrDisableFieldInfo(custommetadata._id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#939393" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                                    </svg>
                                    </div>
                                </div>
                                <input
                                    v-model="customMapper[custommetadata._id]"
                                    type="text"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'FREETEXT'"
                                    class="bg-transparent border rounded input-fields text-light w-100"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                />
                                <textarea
                                    v-model="customMapper[custommetadata._id]"
                                    type="text"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'FREETEXT_MULTILINE'"
                                    class="bg-transparent rounded text-light w-100"
                                    style="margin-inline-start:5px;max-height:200px;min-height: 100px;padding: 4px;
                                    :1px solid #3a3a3a !important;"
                                    :ref="custommetadata.name"
                                    :id="custommetadata._id">
                                </textarea>
                                <input
                                    v-model="customMapper[custommetadata._id]"
                                    type="number"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'INTEGER'"
                                    class="bg-transparent border rounded input-fields text-light w-100"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                />
                                <date-picker
                                    v-model="time1"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'DATE'"
                                    valueType="format"
                                    class="bg-transparent border rounded input-fields text-light w-100"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                ></date-picker>
                                <date-picker
                                    v-model="dateTime"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'DATE_TIME'"
                                    class="bg-transparent border rounded input-fields text-light w-100"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                    valueType="format"
                                    type="datetime"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    lang="en"
                                    confirm
                                ></date-picker>
                                <Multiselect
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'PICKLIST'"
                                    :value="singlePickListMapper[custommetadata._id]"
                                    :options="getSinglePicklistOptions(custommetadata.values)"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                    :allow-empty="true"
                                    deselectLabel=""
                                    track-by="value_id"
                                    label="value"
                                    selectLabel=""
                                    selectedLabel=""
                                    @select="picklistCheckFunc($event,custommetadata._id)"
                                    placeholder="Select picklist"
                                    style="margin-top: 7px;">
                                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                                    </div>
                                    <span slot="noResult">No results.</span>
                                </Multiselect>
                                <Multiselect
                                    v-show="custommetadata.type == 'PICKLIST_MULTIVALUE' && picklistTypeCheck(custommetadata) && isMetadataEdit(custommetadata.name)"
                                    v-model="pickListMapper[custommetadata._id]"
                                    :options="custommetadata.values"
                                    :multiple="true"
                                    :id="custommetadata._id"
                                    @input="saveFields('custom_metadata', (metadataScreenInfo.mandatory_field_id_list != undefined && metadataScreenInfo.mandatory_field_id_list.includes(custommetadata._id)))"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :ref="custommetadata.name"
                                    track-by="value_id"
                                    label="value"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel="">
                                    <span slot="noResult">No results</span>
                                    <span slot="noOptions" style="display:none"></span>
                                    <div slot="tag" slot-scope="option" class="selected-tags-style">
                                    <div class="tags-display-style">{{option.option.value}}</div>
                                        <div class="remove-tag" v-on:click="removeSelectedPicklistOption(option.option,custommetadata._id)">
                                            <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,custommetadata._id)" @focus.prevent :key="scope.option.name"/>
                                    <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                                    </div>
                                </Multiselect>
                                <div v-show="isMetadataEdit(custommetadata.name)">
                                    <div class="d-flex">
                                    <save-icon :wrapcontentwithbutton="true"
                                      tabindex="0" @click.native="saveFields('custom_metadata', (metadataScreenInfo.mandatory_field_id_list != undefined && metadataScreenInfo.mandatory_field_id_list.includes(custommetadata._id)))"
                                    class="save-cancel-icon"
                                    ></save-icon>
                                    <cancel-icon tabindex="0" :wrapcontentwithbutton="true"
                                        @click.native="cancelMetadataDockFields(custommetadata.name)"
                                    class="save-cancel-icon"
                                    ></cancel-icon>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                      </li>
                      <div v-if="isChildExists(custommetadata)" style="
        margin: 0px 8px 4px 11px;
        position: relative;
        width: 95%;
        padding-bottom: 0px;
    " >
                        <RecursiveList :HMData="getHierarchyMetadata(custommetadata)" :parentCM="null" :metadataScreenInf="metadataScreenInfo"
                      :assetDetailsFromParent="assetDetailsFromParent" :master_asset_id="master_asset_id" :screenType="screenType"/>
                      </div>  
                    </template>
                  </div>
                </template>
                </div>
              </div>
            </template>
            <!-- <template>
              <div
                  class="text-left"
                  style="padding: 10px 0px 10px 8px; color: #777"
              >
              <svg  v-if="!showSystemDefinedMetadata" v-on:click="showSystemDefinedMetadata = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <svg v-if="showSystemDefinedMetadata" v-on:click="showSystemDefinedMetadata = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
                <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">System Defined Metadata</span>
              </div>
              <template v-if="showSystemDefinedMetadata">
                <div v-for="eachId in metadataScreenInfo.field_id_list" :key="eachId" class="fields-styles">
                  <div v-if="displayAlwaysFieldsIdList.includes(eachId) || profileDetails.custom_metadata_allId_list ||
                        (profileDetails.custom_metadata_display_config > 0 && fetchedFieldIdList.includes(eachId)) ||
                        selectedRelaventProfileIdList.includes('All')">
                    <div v-for="custommetadata in (customMetadataList.filter((cmdata)=>cmdata._id == eachId))" :key="custommetadata._id">
                      <template v-if="'definition_type' in custommetadata && custommetadata.definition_type == 'system-defined'">
                      <li  :id="'field-'+custommetadata._id" class="d-block" :key="custommetadata._id"
                            @dblclick="editMetadataOnDoubleclick(custommetadata.name,custommetadata._id, custommetadata.type,custommetadata.type == 'PICKLIST_MULTIVALUE')"
                            :class="{'readonlyDiv':metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id),'li-style-change':isMetadataEdit(custommetadata.name)}">
                        <div style="display: flex;">
                            <div class="upload-fields" :class="{readonlyDiv:metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id)}">
                            <div style="display: flex;">
                              <div class="key-style">{{ custommetadata.name }}
                                <span class="readonly-field" v-if="metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id)">
                                    ( non editable )
                                </span>
                              </div>
                              <span style="color:#858585" v-if="metadataScreenInfo.mandatory_field_id_list != undefined && metadataScreenInfo.mandatory_field_id_list.includes(custommetadata._id)">*</span>
                            </div>
                            <div class="value-style d-inline-flex">
                                <div class="w-100" style="display: inherit">
                                <div class="d-inline-flex">
                                    <template v-if="!isMetadataEdit(custommetadata.name)">
                                      <template v-if="custommetadata.type=='PICKLIST_MULTIVALUE'">
                                          <div>
                                            <ul class="tags-display-ul p-0">
                                              <li
                                              v-for="picklist in pickListMapper[custommetadata._id]"
                                              :key="picklist.value_id"
                                              class="view-tags"
                                              >
                                                <div style="position:relative;top:1px">{{ picklist.value }}</div>
                                              </li>
                                            </ul>
                                          </div>
                                      </template>
                                      <template v-else-if="custommetadata.type == 'PICKLIST'">
                                        <span>{{getSinglePicklistVal(custommetadata._id)}}</span>
                                      </template>
                                      <template v-else-if="['DATE', 'DATE_TIME'].includes(custommetadata.type)">
                                        <span>{{getAssetDateTimeValue(custommetadata)}}</span>
                                      </template>
                                      <template v-else>
                                          <span>{{getCustomMetadataValue(custommetadata._id)}}</span>
                                      </template>
                                    </template>
                                    <edit-icon
                                    tabindex="0" @click.native="editMetadataDockFields(custommetadata.name,custommetadata._id, custommetadata.type,(custommetadata.type == 'PICKLIST_MULTIVALUE'))"
                                    v-show="!isMetadataEdit(custommetadata.name) && isMetadataPrivEnabled() &&
                                    !(metadataScreenInfo.read_only_field_id_list != undefined && metadataScreenInfo.read_only_field_id_list.includes(custommetadata._id))"
                                    class="editIcon"
                                    ></edit-icon>
                                    <div class="aboutField" :title="custommetadata.about_field" v-if="Object.keys(custommetadata).includes('about_field') &&
                                    custommetadata.about_field.length" @click="enableOrDisableFieldInfo(custommetadata._id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#939393" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                                    </svg>
                                    </div>
                                </div>
                                <input
                                    v-model="customMapper[custommetadata._id]"
                                    type="text"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'FREETEXT'"
                                    class="bg-transparent border rounded input-fields text-light w-100"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                />
                                <textarea
                                    v-model="customMapper[custommetadata._id]"
                                    type="text"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'FREETEXT_MULTILINE'"
                                    class="bg-transparent rounded text-light w-100"
                                    style="margin-inline-start:5px;max-height:200px;min-height: 100px;padding: 4px;
                                    :1px solid #3a3a3a !important;"
                                    :ref="custommetadata.name"
                                    :id="custommetadata._id">
                                </textarea>
                                <input
                                    v-model="customMapper[custommetadata._id]"
                                    type="number"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'INTEGER'"
                                    class="bg-transparent border rounded input-fields text-light w-100"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                />
                                <date-picker
                                    v-model="time1"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'DATE'"
                                    valueType="format"
                                    class="bg-transparent border rounded input-fields text-light w-100"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                ></date-picker>
                                <date-picker
                                    v-model="dateTime"
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'DATE_TIME'"
                                    class="bg-transparent border rounded input-fields text-light w-100"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                    valueType="format"
                                    type="datetime"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    lang="en"
                                    confirm
                                ></date-picker>
                                <Multiselect
                                    v-if="isMetadataEdit(custommetadata.name) && custommetadata.type == 'PICKLIST'"
                                    :value="singlePickListMapper[custommetadata._id]"
                                    :options="getSinglePicklistOptions(custommetadata.values)"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :id="custommetadata._id"
                                    :ref="custommetadata.name"
                                    :allow-empty="true"
                                    deselectLabel=""
                                    track-by="value_id"
                                    label="value"
                                    selectLabel=""
                                    selectedLabel=""
                                    @select="picklistCheckFunc($event,custommetadata._id)"
                                    placeholder="Select picklist"
                                    style="margin-top: 7px;">
                                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                                    </div>
                                    <span slot="noResult">No results.</span>
                                </Multiselect>
                                <Multiselect
                                    v-show="custommetadata.type == 'PICKLIST_MULTIVALUE' && picklistTypeCheck(custommetadata) && isMetadataEdit(custommetadata.name)"
                                    v-model="pickListMapper[custommetadata._id]"
                                    :options="custommetadata.values"
                                    :multiple="true"
                                    :id="custommetadata._id"
                                    @input="saveFields('custom_metadata', (metadataScreenInfo.mandatory_field_id_list != undefined && metadataScreenInfo.mandatory_field_id_list.includes(custommetadata._id)))"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :ref="custommetadata.name"
                                    track-by="value_id"
                                    label="value"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel="">
                                    <span slot="noResult">No results</span>
                                    <span slot="noOptions" style="display:none"></span>
                                    <div slot="tag" slot-scope="option" class="selected-tags-style">
                                    <div class="tags-display-style">{{option.option.value}}</div>
                                        <div class="remove-tag" v-on:click="removeSelectedPicklistOption(option.option,custommetadata._id)">
                                            <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,custommetadata._id)" @focus.prevent :key="scope.option.name"/>
                                    <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                                    </div>
                                </Multiselect>
                                <div v-show="isMetadataEdit(custommetadata.name)">
                                    <div class="d-flex">
                                    <save-icon :wrapcontentwithbutton="true"
                                      tabindex="0" @click.native="saveFields('custom_metadata', (metadataScreenInfo.mandatory_field_id_list != undefined && metadataScreenInfo.mandatory_field_id_list.includes(custommetadata._id)))"
                                    class="save-cancel-icon"
                                    ></save-icon>
                                    <cancel-icon tabindex="0" :wrapcontentwithbutton="true"
                                        @click.native="cancelMetadataDockFields(custommetadata.name)"
                                    class="save-cancel-icon"
                                    ></cancel-icon>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                      </li>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
            </template> -->
            <li v-if="hiddenFieldIdList.length > 0" class="d-inline-flex" style="    position: relative;
                bottom: 0px;
                inset-inline-start:0px;
                justify-content: start;border:none">
              <div> + {{hiddenFieldIdList.length}} More fields are hidden.</div>
              <div>
                  <a href="#!" v-on:click="handleHiddenFieldsView" style="margin-inline-start: 5px;">Show Fields</a>
              </div>
            </li>
          </template>
        </div>
        <li ref="Subclips" v-show="isEnabled('Sub Clips') && (isVideoFile || isAudioFile) && assetDetails.asset_type != 'subclip'" class="subclips-section" style="padding:15px 0px 10px 8px !important;margin:0px !important">
          <ul>
            <div style="display: flex;justify-content: space-between;">
              <div
                  class="text-left"
                  style="color: #777"
              >
                <svg  v-if="!showSubclips" v-on:click="showSubclips = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                    <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                </svg>
                <svg v-if="showSubclips" v-on:click="showSubclips = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                    <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
                <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">Subclips</span>
                <div @click="enterSubclipEditSection(null,'subclips')" style="float:inline-end">
                  <edit-icon  class="editIcon" style="top:22px !important;"></edit-icon>
                </div>
              </div>
              <!-- <div style="text-align: start;font-size: 18px;">Subclips</div> -->
              <div v-if="isMetadataPrivEnabled()">
                <!-- <div v-if="subclipsList.length > 0" class="edit-icon-style">
                  <svg @click="enterSubclipEditSection()" width="1em" height="1em" style="margin-top: 2px;height:18px;width:24px" viewBox="0 0 16 16" class="bi bi-pen-fill svg-icon" fill="#939393" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                  </svg>
                </div> -->
                <!-- <button @click="enterSubclipEditSection(null,'subclips')" class="btn btn-outline-primary">Add Subclip</button> -->  
              </div>
            </div>
            <!-- <li class="add-subclips-styles" @click="enterSubclipEditSection(null,'subclips')">
              <div style="margin-inline-end:10px">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                </svg>
              </div>
              <div style="font-size: 15px;line-height: 55px;">Add Subclips</div>
            </li> -->
            <template v-if="showSubclips">
                <div v-if="subclipsList.length == 0" class="no-data-found">
                  No subclips yet
                </div>
                <li v-for="subclip in subclipsList" :key="subclip._id" class="display-subclips" style="padding:0px" :class="{'active-subclip-preview': subclip._id === activeSubclipPreview}" @click="previewSubclipMarkinMarkout(subclip)">
                  <div v-if="isMetadataPrivEnabled()" class="actions-on-subclips">
                      <svg v-if="isEnabled('Transcode') && checkContext()" v-on:click.stop.prevent="enterSubclipEditSection(subclip,'media-edit')" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(90deg);" width="1em" height="1em" fill="currentColor" class="bi bi-scissors" viewBox="0 0 16 16">
                        <path d="M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61 3.5 3.5zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>
                        <title>Edit Media</title>
                      </svg>
                      <svg v-if="isEnabled('Share') && isEnabled('Chat')" @click.stop.prevent="handleShareAction(subclip)" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
                        <title>Share In Chat</title>
                        <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                      </svg>
                      <svg v-if="isEnabled('Sub Clips')" v-on:click.stop.prevent="enterSubclipEditSection(subclip,'subclips')" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pen-fill svg-icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                        <title>Edit Subclip</title>
                      </svg>
                      <delete-icon v-on:click.stop.prevent.native="deleteSelectedSubclip(subclip._id)"></delete-icon>  
                  </div>
                  <subclip-rows :subclipsData="subclip" :fileInfo="fileInfo" :customStyles="subclipsRowsStyles" @editSubclipTranscript="editTranscript" @viewTrancsript="loadTranscript" @loadVideo="playTranscript" @previewProxy="previewProxy" :isTagMetadataDock="isTagMetadataDock" :isMetadataDock="isMetadataDock"></subclip-rows>
                </li>
            </template>
          </ul>
        </li>

        <template v-for="list in getMetadataDockListPlugins.filter(op=>!('position' in op))" >
          <component :ref="(el) => setComponentRef(el,list.componentRef)" v-if="evaluatePluginCondition(list)" :key="list.id" :is="list.component" v-bind="{assetDetailsFromParent:assetDetailsFromParent,isAIPrivilegeEnabled,editMetadataDockFields,playTranscript,getDurationFormatAsHHorMMSS,highlightTranscript,from:'metadatadock',fileInfo:fileInfo}"></component>
        </template>
        <template v-for="list in getMetadataDockListPlugins.filter(op=>('position' in op))" >
          <component :ref="(el) => setComponentRef(el,list.componentRef)" v-if="evaluatePluginCondition(list)" :key="list.id" :is="list.component" v-bind="{assetDetailsFromParent:assetDetailsFromParent,isAIPrivilegeEnabled,editMetadataDockFields,playTranscript,getDurationFormatAsHHorMMSS,highlightTranscript,from:'metadatadock',fileInfo:fileInfo}"></component>
        </template> 

        
        <!-- <li ref="Transcript" v-if="isPluginInstalled('Transcript') && assetDetailsFromParent && assetDetailsFromParent.hasOwnProperty('ai_info') &&
        assetDetailsFromParent.ai_info && assetDetailsFromParent.ai_info.transcript &&
        assetDetailsFromParent.ai_info.transcript.length > 0" class="subclips-section" style="margin: 0px !important;padding: 15px 0px 10px 8px !important;">
          <ul>
            <div style="display: flex;justify-content: space-between;">
              <div
                  class="text-left"
                  style="color: #777"
              >
              <svg  v-if="!showTranscriptHighlight" v-on:click="showTranscriptHighlight = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <svg v-if="showTranscriptHighlight" v-on:click="showTranscriptHighlight = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
                <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">Transcript</span>
              </div>
              <edit-icon v-if="isAIPrivilegeEnabled('Transcript', true)"
                    tabindex="0" @click.native="editMetadataDockFields('ai_transcript')"
                    class="editIcon"
                    style="top:22px !important;"
            ></edit-icon>
            </div>
            <template v-if="showTranscriptHighlight">
                <ul class="transcript-wrapper" @dblclick="editMetadataDockFields('ai_transcript')">
                  <li v-for="transcript in assetDetailsFromParent.ai_info.transcript" :key="transcript.uid">
                      <div class="transcript-preview">
                          <div class="transcript-content">
                              <div class="transcript-play transcript-timestamp">
                                  <div style="display: flex;" class="transcript-play-pause" @click="playTranscript(transcript)">
                                    <svg  xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#dbdbdb" viewBox="0 0 16 16" class="bi bi-play-fill"><path  d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path></svg>
                                  </div>
                                  <div class="common-media-in-out-display">
                                      <span>{{getDurationFormatAsHHorMMSS(transcript.media_in)}}</span> - <span>{{getDurationFormatAsHHorMMSS(transcript.media_out)}}</span>
                                  </div>
                              </div>
                              <div class="transcript-spoken-content" v-html="highlightTranscript(transcript.content)">
                                  
                              </div>
                          </div>
                      </div>
                  </li>
                </ul>
            </template>
          </ul>
        </li> -->



        <!-- <li ref="Faces" v-if="isPluginInstalled('Face detection') && assetDetailsFromParent && assetDetailsFromParent.hasOwnProperty('ai_info') && assetDetailsFromParent.ai_info && assetDetailsFromParent.ai_info.face_detection && assetDetailsFromParent.ai_info.face_detection.length > 0" class="subclips-section" style="margin: 0px !important;padding: 15px 0px 10px 8px !important;">
          <ul>
            <div style="display: flex;justify-content: space-between;">
              <div
                  class="text-left"
                  style="color: #777"
              >
              <svg  v-if="!showFaceDetectionHighlight" v-on:click="showFaceDetectionHighlight = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <svg v-if="showFaceDetectionHighlight" v-on:click="showFaceDetectionHighlight = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
                <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">Faces</span>
              </div>
              <edit-icon v-if="isAIPrivilegeEnabled('Face Detection')"
                    tabindex="0" @click.native="editMetadataDockFields('ai_face_detection')"
                    class="editIcon"
                    style="top:22px !important;"
              ></edit-icon>
            </div>
            <template v-if="showFaceDetectionHighlight">
                <ul class="transcript-wrapper" @dblclick="editMetadataDockFields('ai_face_detection')">
                <template v-if="getMimeType == 'video' || getMimeType == 'audio'">
                  <template  v-for="faceObjs in confirmedFaceObjects">
                      <div class="transcript-preview" :key="faceObjs[0].uuid">
                          <div class="transcript-content" style="align-items:flex-start">
                              <div class="transcript-play transcript-timestamp" style="margin-top: 13px;">
                                  <div style="display: flex;" class="transcript-play-pause" @click="playTranscript(faceObjs[0])">
                                    <svg  xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#dbdbdb" viewBox="0 0 16 16" class="bi bi-play-fill"><path  d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path></svg>
                                  </div>
                                  <div class="common-media-in-out-display">                
                                    <span>{{getDurationFormatAsHHorMMSS(faceObjs[0].media_in)}}</span> - <span>{{getDurationFormatAsHHorMMSS(faceObjs[0].media_out)}}</span>
                                  </div>
                              </div>
                              <li>
                                <div v-for="faceObj in faceObjs" style="display:inline-flex" :key="faceObj.uuid">
                                  <div v-if="checkProfileImageExist(faceObj.object_id)" class='user-name-or-image' >
                                      <img :src="checkProfileImageExist(faceObj.object_id)" @error="replaceWithUserIcon($event,faceObj.name)" style="height:100%;border-radius:6px;margin-bottom: 5px">
                                  </div>
                                  <div v-else class="user-name-or-image" :title="faceObj.name" :style="style(faceObj.name)">{{faceObj.name.split("")[0]}}</div>
                                  <div class="transcript-spoken-content" style="margin-top: 4px;" v-html="highlightTranscript(faceObj.name)">
                                  </div>
                                </div>
                              </li>
                          </div>
                      </div>
                      </template>
                  </template>
                  <template v-else-if="getMimeType == 'image'">
                    <li>
                        <FaceDetectionPersonalities :isSearchHighlightRequired="true" :assetDetailsFromParent="assetDetailsFromParent" :imageWidth="160" :faceDetectionList="assetDetailsFromParent.ai_info.face_detection"></FaceDetectionPersonalities>
                    </li>
                  </template>
                </ul>
            </template>
          </ul>
        </li> -->
        <!-- <li ref="Objects" v-if="isPluginInstalled('OBD') && assetDetailsFromParent && assetDetailsFromParent.hasOwnProperty('ai_info') && assetDetailsFromParent.ai_info && assetDetailsFromParent.ai_info.obd && assetDetailsFromParent.ai_info.obd.length > 0" class="subclips-section" style="margin: 0px !important;padding: 15px 0px 10px 8px !important;">
          <ul>
            <div style="display: flex;justify-content: space-between;">
              <div
                  class="text-left"
                  style="color: #777"
              >
              <svg  v-if="!showObdDetection" v-on:click="showObdDetection = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <svg v-if="showObdDetection" v-on:click="showObdDetection = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
                <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">Objects</span>
              </div>
              <edit-icon v-if="isAIPrivilegeEnabled('Object Detection')"
                    tabindex="0" @click.native="editMetadataDockFields('ai_obd')"
                    class="editIcon"
                    style="top:22px !important;"
            ></edit-icon>
            </div>
            <div v-if="showObdDetection"  @dblclick="editMetadataDockFields('ai_obd')" class="value-style d-inline-flex" style="border: 0px solid #4a4a4a;border-radius: 4px;padding: 6px !important;margin: 0px !important;">
                    <div class="w-100">
                      <ul class="tags-display-ul transcript-wrapper p-0" :style="getMimeType == 'image'?'display:inline-flex':'display:block'">
                          <template v-if="getMimeType == 'video'">
                            <template  v-for="objs in confirmedOBDObjects">
                              <div class="transcript-preview" :key="objs[0].uuid">
                                  <div class="transcript-content" style="align-items:flex-start">
                                      <div class="transcript-play transcript-timestamp" style="display:inline-flex;margin-top: 13px">
                                          <div style="display: flex;" class="transcript-play-pause" @click="playTranscript(objs[0])">
                                            <svg  xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#dbdbdb" viewBox="0 0 16 16" class="bi bi-play-fill"><path  d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path></svg>
                                          </div>
                                          <div class="common-media-in-out-display">
                                            <span>{{getDurationFormatAsHHorMMSS(objs[0].media_in)}}</span> - <span>{{getDurationFormatAsHHorMMSS(objs[0].media_out)}}</span>
                                          </div>
                                      </div>
                                      <li>
                                          <div v-for="obj in objs" :key="obj.uuid" class="transcript-spoken-content" v-html="highlightTranscript(obj.name)"></div>
                                      </li>
                                      </div>
                              </div>
                            </template>
                          </template>
                          <template v-else-if="getMimeType == 'image'">
                            <div v-for="obj in assetDetailsFromParent.ai_info.obd" :key="obj.object_id">
                              <li v-if="obj.status == 'confirmed'"
                                  :key="obj.object_id"
                                  class="view-tags">
                                  <div v-html="highlightTranscript(obj.name)"></div>
                              </li>
                            </div>
                          </template>
                      </ul>
                    </div>  
                </div>
          </ul>
        </li> -->

        <!-- <li ref="OCR" v-if="isPluginInstalled('OCR') && assetDetailsFromParent && assetDetailsFromParent.hasOwnProperty('ai_info') && assetDetailsFromParent.ai_info && assetDetailsFromParent.ai_info.ocr && assetDetailsFromParent.ai_info.ocr[0].script.replace('\n','').trim().length > 0" class="subclips-section" style="margin: 0px !important;padding: 15px 0px 10px 8px !important;">
          <ul>
            <div style="display: flex;justify-content: space-between;">
              <div
                  class="text-left"
                  style="color: #777"
              >
              <svg  v-if="!showOCRHighlight" v-on:click="showOCRHighlight = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <svg v-if="showOCRHighlight" v-on:click="showOCRHighlight = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                  <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
                <span style="position:relative;inset-inline-start:1px;top:2px;font-size: 18px;">OCR</span>
              </div>
              <edit-icon v-if="isAIPrivilegeEnabled('OCR')"
                    tabindex="0" @click.native="editMetadataDockFields('ai_ocr')"
                    class="editIcon"
                    style="top:22px !important;"
            ></edit-icon>
            </div>
            <div v-if="showOCRHighlight" @dblclick="editMetadataDockFields('ai_ocr')" v-html="highlightTranscript(assetDetailsFromParent.ai_info.ocr[0].script)"
                  ref="ocr" style="padding: 10px;text-align: start;border: 0px solid #4a4a4a;border-radius: 4px;">
            </div>
          </ul>
        </li> -->
      </div>
    </ul>
    <picture-in-picture ref="pic-pic" @hook:mounted="picPicZindex(9999, 'pic-pic')" calss="hide-picture" v-cloak v-if="openPip" initiator="TagMetadataComponent-pip" :selectedFile="selectedFileInfo"  :disablePreviewDocker="true" @closeMiniPlayer="closeMinimisedPlayer"></picture-in-picture>
        <ImagePreviewDialog ref="fullscreen-pic" @hook:mounted="picPicZindex(9999, 'fullscreen-pic')" class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="selectedFileInfo" @closeMiniPlayer="closeMinimisedPlayer"
        v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
        <MiniPlayer @closeMiniPlayer="isMiniPlayerVisible = false" v-if="isMiniPlayerVisible" :subclipDetails="playSubclipObject" :transcriptPlayObject="transcriptPlayObject" ref="miniPlayerRef" initiator="TagMetadataComponent" :selectedFile="fileInfo"></MiniPlayer>
    <select-tags v-if="((isTagsBrowse) && (Object.keys(assetDetails).length != 0))" :selectedTagsFromParent="selectedTags"
      :fileInfo="assetDetails" @close="closeTagsBrowse" @saveTagsSelectedFromBrowse="saveTagsSelectedFromBrowse" ref="tagsBrowse"></select-tags>
      <ShareInChat v-if="openShareInChat" :fileInfo="assetDetailsOfSubclip" @close="closeShareInChat()"></ShareInChat>
      <!--AudioPlayer :fileInfo="fileInfo" v-if="isAudioFile" :transcriptPlayObject="transcriptPlayObject"></AudioPlayer> -->
  </div>
</template>
<script>
import highlightMixin from '../../mixins/TagMetadataComponentMixin.js';
import DatePicker from "vue2-datepicker";
import selectTags from "../tags/TagsBrowse.vue"
import EditIcon from "../core/InlineEditField";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import "vue2-datepicker/index.css";
import BrowseIcon from "../core/InlineBrowseField.vue";
import Multiselect from 'vue-multiselect'
import {NotifierConstants} from "../../components.constants.js";
import SubclipRows from "../subclips/SubclipsRows.vue";
import deleteIcon from "../core/InlineDeleteIcon.vue";
import CatalogDropdown from "../categories/CatalogMultiselectDropdown.vue";
import ShareInChat from "../core/ShareInChat.vue";
// import FaceDetectionPersonalities from '../FusionAI/DetectedPersonalities.vue';
import MiniPlayer from '../files/MiniPlayer.vue';
import pictureInPicture from "../files/MiniPlayer.vue";
import imagePreview from "../core/ImagePreviewDialog.vue";
import departmentsCommonComponent from "../miscellaneous/departmentsCommonComponent.vue";
import RecursiveList from "./RecursiveList.vue";
import Utils from '../../components.utils.js';
import { mapGetters , mapMutations, mapActions} from 'vuex';
//import AudioPlayer from "../customAudioPlayer/AudioPlayerComponent.vue";

export default {
  mixins:[highlightMixin],
  props:["displayMessage","assetDetailsFromParent","isMetadataDock","enableSubclip","master_asset_id","screenType","isVideoFile",'fileInfo','isTagMetadataDock'],
  data() {
    return {
      selectedFilter:'Metadata',
      metadataPromptsComponent: null,
      metadataSmartExtractComponent:null,
      showSmartExtractionMenu: false,
    };
  },
  components:{
    "catalog-dropdown":CatalogDropdown,
    "browse-icon":BrowseIcon,
    "date-picker":DatePicker,
    "select-tags":selectTags,
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    Multiselect: Multiselect,
    "subclip-rows":SubclipRows,
    ShareInChat,
    "delete-icon":deleteIcon,
    // AudioWaveformComp
    // FaceDetectionPersonalities,
    MiniPlayer,
    "picture-in-picture":pictureInPicture,
    "ImagePreviewDialog":imagePreview,
    departmentsCommonComponent,
    RecursiveList,
    //AudioPlayer
  },
  methods:{
    reloadMetadataFieldValues(){
      let assetId = this.assetDetails.asset_id || this.assetDetails._id;
      // if (assetId && (Utils.getCookieValue("context") == 'catalogs-display')){
      //   this.updateMetadataOfAssetsThroughNotification(assetId);
      // }else{
        let fileId = this.assetDetails.file_uid;
      //   this.updateMetadataOfFilesThroughNotification(fileId);
      // }

      let payload = {}
        if (assetId && (Utils.getCookieValue("context") == 'catalogs-display')){
          payload.params = {assetId: assetId}
          this.getAssetInfoFromServer(payload).then((data) => {
              // this.setAssetInfo(data["asset"])
              Object.assign(this.assetDetails, data["asset"]);
              this.$emit("updateAssetDeatils", data["asset"]);
          })
        }else{
          payload.params = {fileId: fileId, metadata:true}
          this.getFileInfoFromServer(payload).then((data) => {
              // this.setAssetInfo(data["file"])
              Object.assign(this.assetDetails, data["file"]);
              this.$emit("updateAssetDeatils", data["file"])
          })
        }
    },
    openSmartExtraction() {
      this.showSmartExtractionMenu = false;

      const component =
          // this.$refs.metadataSmartExtractRef;
          this.$refs.AIPromptsRef;

      /*
      * Dynamic component ref can sometimes
      * come as array in Vue 2.
      */
      const smartExtractComponent =
          Array.isArray(component)
              ? component[0]
              : component;

      if (
          smartExtractComponent &&
          smartExtractComponent.openPromptSelection
      ) {
          smartExtractComponent.openPromptSelection();
      }
    },

    getAIButtonStyles() {
      return {
        // 'inset-inline-end': this.isMetadataDock?'0px':'0px',
        'inset-inline-end':'0px',
        right:this.isRTL()?'unset !important' : '18px !important',
        top: this.isMetadataDock?'8px':'9px'
      }
    },
     getMetadataSmartExtractButtonStyles(){
        return {
          // 'inset-inline-end': this.isMetadataDock?'0px':'0px',
          'inset-inline-end':'0px',
          right:this.isRTL()?'unset !important' : '18px !important',
          top: this.isMetadataDock?'8px':'9px'
        }
      },
    setComponentRef(comp,name){
      if(name && comp && comp.$el)
        this.$refs[name] = comp.$el;
    },
    evaluatePluginCondition(list){
      return list.evalCondition(this);
    },
    changeFilter(tabName){
      this.selectedFilter = tabName;
      if(tabName == 'Metadata'){
        this.showMetadata = true;
      }
      if(tabName == 'Subclips'){
        this.showSubclips = true;
      }
      if(tabName == 'Transcript'){
        this.showTranscriptHighlight = true;
      }
      if(tabName == 'Faces'){
        this.showFaceDetectionHighlight = true;
      }
      if(tabName == 'Objects'){
        this.showObdDetection = true;
      }
      if(tabName == 'OCR'){
        this.showOCRHighlight = true;
      }
      if(tabName == 'AdvanceMetadata'){
        this.showAdvanceMetadata = true;
      }
      const element = this.$refs[tabName];
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        element.classList.add('blink');

        setTimeout(() => {
          element.classList.remove('blink');
        }, 1000);
        }
      },
      ...mapMutations("registry",["updateMetadataDockPlugins"]),
      ...mapActions("assets", ["getAssetInfoFromServer"]),
      ...mapActions("files", ["getFileInfoFromServer"]),
  },
  async created(){
    this.addWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingsValueFromNotification, parent:"TagMetadataComponent"}); 
    this.addWSEventListener({eventname:["JOB_STATUS_UPDATE"],callback:this.handleBulkMetadataNotification,parent: "TagMetadataComponent"})
    for(let i = 0; i < this.getMetadataDockListPlugins.length; i++){
        if(!Object.prototype.hasOwnProperty.call(this.getMetadataDockListPlugins[i],'component')){
            console.log(`this.getMetadataDockListPlugins[i]`,this.getMetadataDockListPlugins[i],'[this.getMetadataDockListPlugins[i].pluginBundle.js]',[this.getMetadataDockListPlugins[i].pluginBundle.js]);
            let compInfo = await  Utils.loadPluginBundles([this.getMetadataDockListPlugins[i].pluginBundle.js],this.getMetadataDockListPlugins[i].componentLoadedEventName);
            console.log("............compInfo metadatadock",compInfo);
            if(compInfo && Array.isArray(compInfo) && compInfo.length){
              Utils.loadCssBundle(this.getMetadataDockListPlugins[i].pluginBundle.css);
              const ev = new Event('register-routes');
              if(Object.prototype.hasOwnProperty.call(compInfo[0] , 'pluginStore'))
                ev.pluginStore = compInfo[0].pluginStore;
              parent.document.body.dispatchEvent(ev);
              if('renderComponent' in this.getMetadataDockListPlugins[i]){
                this.updateMetadataDockPlugins({id:this.getMetadataDockListPlugins[i].id,data:{component:compInfo[0].components[this.getMetadataDockListPlugins[i].renderComponent]}});
              }else{
                this.updateMetadataDockPlugins({id:this.getMetadataDockListPlugins[i].id,data:{component:compInfo[0].components}});
              }
            }
        }
    }
    this.refreshStartData("user_groups");
    this.refreshStartData("metadata_profiles");
    this.refreshStartData('custom_metadatas');
    this.refreshStartData("screens");
    this.isLoaded=false;
    if(this.enableSubclip != undefined && this.enableSubclip){
    this.isSubclipEnabled = true;
    }else{
    this.isSubclipEnabled = false;
    }
    if(this.assetDetailsFromParent != undefined){
    if ("asset_id" in this.assetDetailsFromParent){
        this.assetId = this.assetDetailsFromParent.asset_id
    }else{
        this.assetId = this.assetDetailsFromParent._id;
    }
    this.refreshFileInfoAndShowAsset(this.assetDetailsFromParent) 
    }
    this.getDepartments().then((data) => {
        this.departmentsList = data.department;
    }) 

  },
  mounted(){
      document.getElementById('metadatafirstediticon').focus();
      let searchValue = this.$parent.globalSearchedValue;
      this.globalSearchText = String(searchValue);
      try{ 
           Utils.loadPluginBundles([{id:'metadata_prompts_bundle_js',jsUrl:`${window.location.origin}/damplugins/ai_prompts/web/metadata_prompts_bundle.js`}],'metadata-prompts-components-loaded').then((event)=>{
            if(event && Array.isArray(event) && event.length){
                if(event[0].components['TriggerPrompts']){
                  const ev = new Event('register-routes');
                  if(Object.prototype.hasOwnProperty.call(event[0] , 'pluginStore'))
                    ev.pluginStore = event[0].pluginStore;
                  parent.document.body.dispatchEvent(ev);
                  Utils.loadCssBundle({id:'metadata_prompts_bundle_css',cssUrl:`${window.location.origin}/damplugins/ai_prompts/web/metadata_prompts_bundle.css`});
                  this.metadataPromptsComponent = event[0].components['TriggerPrompts'];
                }
              }
          });
        }catch(e){console.log(e)}

         try{ 
           Utils.loadPluginBundles([{id:'metadata_smart_Extraction_bundle_js',jsUrl:`${window.location.origin}/damplugins/FusionAI/web/metadata_smart_Extraction_bundle.js`}],'metadata-smart-extraction-components-loaded').then((event)=>{
            if(event && Array.isArray(event) && event.length){
                if(event[0].components['medtadataSmartExtract']){
                  const ev = new Event('register-routes');
                  if(Object.prototype.hasOwnProperty.call(event[0] , 'pluginStore'))
                    ev.pluginStore = event[0].pluginStore;
                  parent.document.body.dispatchEvent(ev);
                  Utils.loadCssBundle({id:'metadata_smart_Extraction_bundle_css',cssUrl:`${window.location.origin}/damplugins/FusionAI/web/metadata_smart_Extraction_bundle.css`});
                  this.metadataSmartExtractComponent = event[0].components['medtadataSmartExtract'];
                }
              }
          });
        }catch(e){console.log(e)}
  },
  computed:{
    shouldShowMetadata() {
      return (
        this.isEnabled('Sub Clips') && (this.isVideoFile || this.isAudioFile) && this.assetDetails.asset_type != 'subclip' ||
        this.isPluginInstalled('Transcript') && this.assetDetailsFromParent?.ai_info?.transcript?.length > 0 ||
        this.isPluginInstalled('Face detection') && this.assetDetailsFromParent?.ai_info?.face_detection?.length > 0 ||
        this.isPluginInstalled('OBD') && this.assetDetailsFromParent?.ai_info?.obd?.length > 0 ||
        this.isPluginInstalled('OCR') && this.assetDetailsFromParent?.ai_info?.ocr?.[0]?.script?.replace('\n', '').trim().length > 0 ||
        (this.getMetadataDockListPlugins && this.getMetadataDockListPlugins.length > 0)
      );
    },
    isAudioFile(){
        try {
            if(this.fileInfo){
              return  Utils.getFileMediaType(this.fileInfo) == 'audio';//this.fileInfo.mime_type.startsWith("audio");
            }   
            
        } catch (err) {
            console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
        }
        return false
    },
    ...mapGetters("registry",["getMetadataDockListPlugins"]),
  },
  beforeDestroy(){
    this.removeWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingsValueFromNotification, parent:"TagMetadataComponent"}); 
    this.removeWSEventListener({eventname:["JOB_STATUS_UPDATE"],callback:this.handleBulkMetadataNotification,parent: "TagMetadataComponent"})}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $readOnly-bg-color: #1e2326 !important;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $highlight-font-color:#ff9800;

.actions-on-subclips{
    position: absolute;
    inset-inline-end: 0px;
    border: $border-color;
    width: auto;
    height: 35px;
    border-radius: 4px;
    top: 4px;
    inset-inline-end: 3px;
    padding: 0px 5px;
    background: $bg-color-on-hover;
    display:inline-flex;
    svg{
        margin:2px;
        background: #d1d2d31a;
        padding: 4px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
        margin-inline-end: 5px;
        color: #c0c0c0;
    }
    svg:hover{
        background: #fdfeff54;
    }
}
.actions-on-subclips{
    visibility: hidden;
}


.li-style-change{
  border: 1px solid $metadata-border-color-on-hover !important;
}

.metadata-dock-ul li .aboutField {
  visibility: hidden;
}

.metadata-dock-ul li:hover .aboutField {
  visibility: visible;
}

.readonlyDiv{
    background: $readOnly-bg-color;
    border: none !important;
}

.readonly-field{
  color:$dull-text-color;
  font-size:12px;
}

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

.selected-tags-style{
  background: $bg-color-on-hover;
  border: 1px solid $tags-border-color;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 30px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 4px !important;
  padding-inline-end: 4px !important;
  .remove-tag{
    line-height:18px;
  }
}

.tags-display-ul{
  margin-inline-start:0px;
    list-style-type: none;
    display: inline-flex;
    flex-wrap: wrap;
    margin-top: 0;
    width: 100%;
    justify-content: start;
    overflow: auto;
  label{
    padding: 0px 5px;
  }
}
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background:$primary-background !important;
    border: $border-color;
    .modal-body{
      background: $primary-background;
      overflow:auto;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-flex;
      width:100%;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

    ::-webkit-scrollbar {
     width: 8px;
     height:5px;
    }

    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}
.activeNav,.activeNav:hover{
    color: $active-blue !important;
    border: 1px solid $metadata-border-color-on-hover;
}
.row{
  margin:-12px !important;
  margin-inline-start:0px !important;
}

.metadata-fields{
  background: $primary-background;
  border-inline-start: $secondary-border-color !important;
}

.modal-header,.modal-footer{
    border: none !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}
.upload-fields{
    width: 100%;
    border-radius: 5px;
}

.modal-header .close {
    margin: 0px !important;
    padding:0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    margin-top:1%;
    display:inline-flex !important;
    flex-wrap: nowrap !important;
    button{
        border-radius: 5px;
        width: 70px;
        font-size:14px;
        float:inline-end;
    }
}


.secondary-btn-style{
  color:$text-color;
}

.modal-footer{
    justify-content: start;
}

.view-tags {
    font-size: 12px !important;
    min-height: 28px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border: 1px solid $tags-border-color !important;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 0px 5px !important;
    text-align: center;
    width: auto !important;
    justify-content: center;
    padding-top: 4px !important;
    background: $tags-background-color !important;
  span, div {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

span{
  white-space: pre-wrap;
}

.view-tags:hover {
  border: $border-color !important;
}

.activeTag{
    color: $active-blue !important;
}

.align-texts{
  li{
    .value-style{
      padding-inline-start: 5px !important;
    }
  }
}

.metadata-dock-ul {
  list-style-type: none;
  padding: 0px;
  user-select: none; 
  position:relative;
  margin-inline-start:0px;
  width:100%;
  background:$primary-background;
  overflow:hidden;
  .metadata-dock-sub-div{
    overflow:auto;
    overflow-x:hidden;
  }
  .fields-styles{
      margin-bottom:8px;
    li{
      margin-bottom:1px;
    }
  }
  li {
    display: inline-block;
    width: 100%;
    padding: 7px;
    border: $border-color;
    border-radius: 4px;
    margin: 4px 8px;
    width: 96%;
    position: relative;
    background:$primary-background;
    .key-style {
      color: $dull-text-color;
      width: auto;
      text-align: start;
      font-size: 14px;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 3px;
    }
    .value-style {
      color: $text-color;
      width: 97%;
      text-align: start;
      padding-top: 3px;
      padding-bottom: 3px;
      padding-inline-end: 5px;
      padding-inline-start: 0px;
      user-select: text !important; 
      cursor:text;
      .slug-ellipsis {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }
      .save-cancel-icon{
        position:relative;
        top:10px;
        inset-inline-start:5px;
        color:#fff;
      }
      .browse-icon{
        color:#636363 !important;
      }
    }
  }
  li:hover{
    border:1px solid $metadata-border-color-on-hover
  }
}

.display-subclips{
  width:100% !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.display-subclips:hover{
  .actions-on-subclips{
    visibility: visible;
  }
}

.metadata-dock-ul li .editIcon {
  opacity: 0;
}

.metadata-dock-ul li:hover .editIcon,.metadata-dock-ul li:focus-within .editIcon {
  opacity:1;
}
.editIcon {
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 2%;
    top: 10px;
}

.aboutField{
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 1%;
    top: 45%;
}
.input-fields {
  min-width: 250Px;
  padding-inline-start:5px;
  padding-top: 2px;
  height:38px;
  outline: none;
  --saf-0: rgba(var(--sk_highlight,18,100,163),1);
  box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
  border-radius: 4px;
  border-color: transparent;
  -webkit-appearance: none;
}

.text-light{
  color: #b6b6b6 !important;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.show-tags-delete{
  position: relative;
  top: 2px;
}

::v-deep{
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
    background:$primary-background;
}
.theme--light.v-chip {
    border-color:#3a3a3a !important;
    color:$text-color;
}

.theme--light.v-chip:not(.v-chip--active) {
    background: $primary-background;
}

.v-list-item--link:before{
  background-color:$primary-background;
}
.vjs_video_3-dimensions, .video-js{
    height:350px;
    width:100% !important;
}
.video-js{
    height:350px;
    width:100% !important;
}
.mx-input{
    background-color:$primary-background !important;
    border: none !important;
    color: #eee !important;
}
.mx-datepicker-main{
    border: 1px solid #2f2f2f !important;
    background: $primary-background !important;
}
.mx-calendar-content .cell:hover{
    background-color: $bg-color-on-hover !important;
}
.mx-datepicker-range{
  width:100%
}
.mx-datepicker{
  padding:0px !important;
}
.mx-calendar-content .cell:hover {
    color: #000000;
    background-color: #7d99b1;
}
.mx-icon-calendar{
  color: $dull-text-color ;
}
.mx-icon-clear{
  color: $dull-text-color;
}
}
.secondary-btn-style:hover{
  text-decoration: underline;
}

.assets-details-in-metadata-manager{
    height:calc(100% - 348px);
    overflow:auto;
    padding:0px 15px;
}

.metadata-dock-ul{
    height:calc(100% - 22px); //22px is substracting bcz margin is given so can't give 100%;
    display:inline-block;
}

.metadata-dock-ul li:focus {
  border: 1px solid $active-blue !important;
}
ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:30%;
            text-align: start;
        }
        .value-style{
            color: #b6b6b6;
            width: 70%;
            text-align: start;
            user-select: text !important; 
            cursor:text;
        }
    }
}

.selected-thumbnail-display{
    width: 100%;
    display: inline-block;
    max-width: 50%;
    img{
        height:100%;
        width:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}


::v-deep{
  .multiselect {
    margin: 3px 0px;
  }

  .multiselect_tags{
    min-height: 40px !important;
    height: 40px !important;
    padding: 8px 40px 0 8px  !important;
    border-radius: 5px !important;
  }
  .multiselect__content-wrapper {
    display: none;
  }
  .multiselect__tag, .tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
  }
  .multiselect__tags, .tags-style {
    background: transparent !important;
    border: $border-color !important;
  }
  .multiselect__option--highlight {
    background: $bg-color-on-hover !important;
  }
  .multiselect__content {
    background: $secondary-background-color !important;
  }
  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
    word-break: break-all;
  }
  .multiselect__single{
    padding-inline-start: 9px !important;
    margin-top: 0px !important;
    padding-top: 6px !important;
  }
  .multiselect__input{
      padding-top:0px !important;
  }

  .multiselect__tag-icon {
    color: $text-color !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $bg-color-on-hover !important;
    color: $text-color !important;
  }
  .multiselect__tag-icon:after {
    color: $secondary-text-color !important;
    font-size: 23px;
  }

  .multiselect__tag-icon {
    visibility: hidden;
  }

  .multiselect__tag:hover .multiselect__tag-icon {
    visibility: visible;
  }
  .multiselect__tags:focus, .multiselect__input:focus{
    outline: none;
    height: 38px;
    bottom: 0px;
    inset-inline-start:0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
    }

  .multiselect * {
    font-size: $input-field-and-label-font-size;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 8px !important;
    padding-inline-start:8px;
  }
  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width: 100%;
    min-height: 38px !important;
    height:auto !important;
  }
  .multiselect__option--selected {
    background: $bg-color-on-hover !important;
    color: $text-color;
  }
  .multiselect__content-wrapper {
    border: 1px solid $bg-color-on-hover !important;
    position: absolute !important;
    display: block;
    background: $text-color;
    width: 100% !important;
    max-height: 180px !important;
    overflow: auto;
    border: 1px solid $text-color;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
  }

  .multiselect--above .multiselect__content-wrapper {
    background: $secondary-background-color !important;
  }
  .multiselect__tags {
    padding: 4px 0px 5px 0px; 
  }
  .multiselect__tags-wrap{
    max-height:150px !important;
    display: inline-block;
    overflow: auto;
  }
   .multiselect__tags-wrap::-webkit-scrollbar {
     width: 8px;
    }

    .multiselect__tags-wrap::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    .multiselect__tags-wrap::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    .multiselect__tags-wrap::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

    .multiselect__content-wrapper::-webkit-scrollbar {
     width: 8px;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-track {
      background: #22272b !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

    font[color~=OrangeRed] {
      color: $highlight-font-color !important;
    }
}

.audio-player{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}
.label-tree-style{
  font-size: 12px !important;
  color:$dull-text-color;
  margin-top:4px;
  word-break: break-all;
  white-space: pre-wrap;
  margin-inline-start:12px;
}

.all-users-selection:hover{
  background: $bg-color-on-hover;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}


input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
    margin-inline-end: 5px;
}

.browse-icon{
    position: relative;
    inset-inline-start:8px;
    top: 3px;
}

.table td, .table th {
    border-top: none;
    padding:0px;
}

.display-as-tags{
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: start;
    float: inline-start;
}

.select-catalog-field{
    width: 101%;
    .value-style{
      width:100%;
    }
}

.user-name-or-image {
  height: 30px;
  width: 30px;
  border: $border-color;
  border-radius: 10px;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-top: 3px;
  margin-inline-start: 5px;
}

.user-name-or-image-in-selected-option{
  border: $border-color;
  height: 26px;
  width: 26px;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  text-transform: uppercase;
  margin-top: -1px;
  margin-inline-start: -1px;
  }

.tags-style{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: 2px;
    height: 27px;
    margin-inline-start: 3px;
  .user-name-display-as-tags{
      line-height: 27px;
      margin-inline-start: 6px;
  }
}

.remove-tag{
  color:$dull-text-color;
  line-height: 25px;
}

.remove-tag:hover{
  color:$text-color;
}

textarea{
  height:150px !important;
  resize: none;
  overflow: auto;
}
.edit-icon-style{
  visibility: hidden;
  position: absolute;
  top:4px;
  inset-inline-end:5px;
  display:inline-flex;
  svg{
      margin-inline-end:5px;
  }
}

.subclips-section:hover{
  .edit-icon-style{
    position: absolute;
    top:4px;
    inset-inline-end:5px;
    display:inline-flex;
    svg{
      margin-inline-end:5px;
    }
  }
}
.subclips-section{
  background:transparent !important;
  padding:0px !important;
  border:none !important;
  margin-inline-end:0px !important;
  ul{
    margin-inline-start:0px;
    .display-subclips{
      margin:4px 0px !important;
    }
  }
}

.active-subclip-preview{
  border: 2px solid $active-blue !important;
}

.no-data-found{
  color: $secondary-text-color;
  text-align: center;
  margin-bottom:10px;
}

 .icon-background-on-hover:hover{
    background: #d1d2d31a;
    }

.icon-background-on-hover{
    padding: 6px;
    height: 28px;
    width: 28px;
    border-radius: 4px;
    }

.add-subclips-styles{
    display: inline-flex;
    height: 57px;
    border: 1px solid $add-button-border-color;
    border-radius: 10px;
    width: 97%;
    justify-content: center;
    line-height: 52px;
    color:$add-button-text-color;
}

.add-subclips-styles:hover{
    border: 1px solid $add-button-border-on-hover;
    color:$add-button-text-color-hover;
}

.transcript-wrapper{
  li{
    border: none !important;
    border-bottom: 1px solid #242424 !important;
    border-radius: 0 !important;
  }
  li:last-child{
    border-bottom: 0 !important;
  }
  .transcript-preview {
       :hover .transcript-play-pause{
          // visibility: visible;
          svg{
            fill:#eee !important;
          }
       }
      .transcript-content{
        display: flex;
        align-items: flex-start;
        text-align: start;
      }
      .transcript-play.transcript-timestamp{
        display: flex;
        align-items: center;
      }
      .transcript-spoken-content{
          margin-inline-start: 6px;
          text-align: start;
          user-select: text;
          cursor: auto;
          word-break: break-word;
      }
      .transcript-play-pause{
        //  visibility: hidden;
        svg{
          fill:#5e5e5e !important;
        }
      }

      .common-media-in-out-display{
          font-size: 14px;
          background: rgb(52, 52, 52);
          padding: 4px 5px; 
          justify-content: start; 
          display: flex; 
          border-radius: 3px;
          color: rgb(238, 238, 238) !important;
          gap:3px;
      }
  }
}

.config-desc{
  color: $dull-text-color;
  font-size: 15px;
  margin-top: 1px;
}

.custom-switch .custom-control-label::before{
  background: transparent;
}
.custom-control-input:checked~.custom-control-label:before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff !important;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.select-filters{
  display: flex;
  padding: 5px;
  position: sticky;
  top: 0px;
  background: #1a1d21;
  // z-index: 999;    //commented this line bcz of z-index it was overlapping on global langauge droddown when it opens 
  overflow-x:auto;

  width:calc(100% - 40px); //css to support reload option
  overflow-y:hidden; //css to support reload option
  .notification-filters{
      border:$border-color;
      border-radius: 20px;
      padding: 12px;
      display: flex;
      align-items: center;
      margin-inline-end: 5px;
      height:30px;
      color: $secondary-text-color;
      // background: $tags-background-color;
  }
}

.activeFilter{
  color: #007bfc !important;
  border:1px solid #007bfc !important;
}

.blink {
 background: #212529 !important;
}

.smart-extraction-dropdown-wrapper {
    display: inline-block;
    position: absolute;
    top:18px;
    right: 12px;
    vertical-align: middle;
    margin-inline-start: 5px;
}

.smart-extraction-dropdown-icon {
    cursor: pointer;
    color: #777;
}

.smart-extraction-dropdown-icon:hover {
    color: #eee;
}

.smart-extraction-dropdown-menu {
    position: absolute;

    top: 24px;
    inset-inline-end: 0;

    min-width: 220px;

    background: #15181b;

    border: 1px solid #3c3c3c;
    border-radius: 4px;

    z-index: 999999;

    box-shadow:
        0 5px 15px rgba(0, 0, 0, 0.35);
}

.smart-extraction-dropdown-item {
    padding: 9px 12px;

    color: #eee;

    font-size: 12px;

    cursor: pointer;

    white-space: nowrap;
}

.smart-extraction-dropdown-item:hover {
    background: #22272b;
}

.metadata-refresh-option{
  border-radius: 6px;
  float: inline-end;
  position: relative;
  border: 1px solid #383838;
  padding: 3px 4px;
  height: 30px;
  width: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  svg{
    fill: #919191;
  }
}

.metadata-refresh-option:hover{
  background: $bg-color-on-hover !important;
  border: 1px solid #979595 !important;
  svg{
    fill: #eee !important;
  }  
}

</style>
